import React, {useState, useEffect} from 'react'
// Style
import './mycard.style.css'
// Constant
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
import { AddOn } from '../../_actions/add-on'
// Liff (Line)
import liff from '@line/liff'
// Card (Silver)
import SilverNhCard from '../../assets/images/cards/card NH (silver).png'
import SilverNhBadge_Active from '../../assets/images/cards/silver(active).png'
import SilverNhBadge_Inactive from '../../assets/images/cards/silver(inactive).png'
// Card (Gold)
import GoldNhCard from '../../assets/images/cards/card NH (gold).png'
import GoldNhBadge_Active from '../../assets/images/cards/gold(active).png'
import GoldNhBadge_Inactive from '../../assets/images/cards/gold(inactive).png'
// Card (Platinum)
import PlatNhCard from '../../assets/images/cards/card NH (platinum).png'
import PlatNhBadge_Active from '../../assets/images/cards/platinum(active).png'
import PlatNhBadge_Inactive from '../../assets/images/cards/platinum(inactive).png'
// Icons
import RefreshIcon from '../../assets/images/icons/refresh.png'
import ArrowRight from '../../assets/images/icons/arrow-r.png'
import CardProfileIcon from '../../assets/images/icons/card-profile.png'
import CardMoreInfoIcon from '../../assets/images/icons/card-moreinfo.png'
import InviteFriends from '../../assets/images/icons/invitef-icon.png'
import UpdateKYC_ICON from '../../assets/images/icons/update-kyc.png'
// Components
import Overlay from '../../components/Overlay'
import CardDetails from '../../components/CardDetails'
// Moment
import moment from 'moment-timezone'
import { DecryptedOBJ, EncryptedOBJ, EncryptedText } from '../../utils/Encryption'
import { authenAll, getJWT_Patient, getJWTbyPatientID, getPatient, JWTAuthen, patientVerifySignIn, SignInPhone } from '../../_actions/sso.authen'
import lineConfig from '../../_actions/authLine/lineConfig'
import useLineLogin from '../../_actions/authLine/lineLogin'
import { ALERT } from '../../components/CustomAlert'
import { getMemberLab, isMembership, isMembershipNonLab } from '../../_actions/lineoa.authen'

function MyCard() {

    const [openDetail, setOpenDetail] = useState(false); 
    const [loading, setLoading] = useState(true);
    const [cardData, setCardData] = useState({
        cardid: 0,
        cardNo: "",
        cardFirstname: "",
        cardLastname: "",
        cardBirthday: "",
        cardPhoneno: "",
        cardEmail: "",
        tierLab: 0,
        cardIcon_Lab: "",
        cardImg_Lab: "",
        tiernonLab: 0,
        cardIcon_nonLab: "",
        cardImg_nonLab: "",
        LabPoint: 0,
        nonLabPoint: 0,
        Lab_accumulated_amount: 0,
        nonLab_accumulated_amount: 0,
        // เพิ่มเติม
        current_time_data: "",
        point_expired: ""
    });
    const [cardDetail, setCardDetail] = useState({
        accumulation: "",
        redemption: "",
        tierTitle: ""
    });

    useEffect(() => {
        dataInit();
    }, []);

    const dataInit = async() => {
        // let memberInfoInit = await getMemberInfoInit(); // ไม่ได้ใช้แล้ว
        // set url callback
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        await authenAll(lineConfig.mycard);
        let memberCode = await checkUserInit();
        await getCardInit(memberCode);
        await getCardDetailInit();
        kycInit();
        handleLoader('inactive');
    }

    const kycInit = async() => {
        return new Promise(async resolve => {
            try{
                let isMember = await isMembership();
                let isMemberNonLab = await isMembershipNonLab();
                console.log('is membership: ', isMember);
                console.log('is membership nonlab: ', isMemberNonLab);
                if(isMember === true) // member lab
                {
                    let member = await getMemberLab(); // line oa
                    let jwt = await JWTAuthen(); // sso
                    let userRes = await SignInPhone(jwt, member.Phoneno); // sso
                    console.log('member: ', member);
                    console.log('userRes: ', userRes);
                    
                    let jwtData = await JWTAuthen(); // sso
                    // set 
                    let enc_res = EncryptedOBJ(userRes);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, enc_res)
            
            
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let udid = lineProfile.user_id;
            
                    let headers = {
                        token: jwtData.token,
                        userRef: udid,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
                    let rawReq = {
                        "refEXP": userRes.refEXP,
                        "isType": userRes.isType,
                        "refAction": userRes.refAction,
                        "refType": userRes.refType,
                    }
                    let reqData = {
                        data: EncryptedOBJ(rawReq)
                    }
                    let verifyData = await patientVerifySignIn(reqData, headers)
                    let jwtPatient = await getJWTbyPatientID(verifyData.patientid);
                    console.log('Verify SignIn: ', verifyData);
                    console.log('jwt patient: ', jwtPatient);
                    
                    let headers_2 = {
                        token: jwtPatient.token,
                        userRef: verifyData.patientid,
                        authorizeRef: jwtPatient.authorizeRef,
                        channalRef: jwtPatient.channalRef
                    }
                    let rawReq_2 = {
                        "refEXP": verifyData.refEXP,
                        "isType": verifyData.isType,
                        "refAction": verifyData.refAction,
                        "refType": verifyData.refType,
                    }
                    let reqData_2 = {
                        data: EncryptedOBJ(rawReq_2)
                    }
            
                    let patientData = await getPatient(reqData_2, headers_2)
                    console.log('patientData: ', patientData);
                    if(!!patientData)
                    {
                        if(patientData.data.isUpdateKYC)
                        {
                            ALERT.AlertUpdateKYC();
                        }
                    }else
                    {
                        ALERT.customAlert('ผิดพลาด', 'ไม่พบข้อมูลการยืนยันตัวตน', 'ยืนยันตัวตน', () => location.href = `${Base_API.pathWeb}/n-health/mycard`);
                    }
                    resolve();
                } 
            }catch(err)
            {
                console.error('KYC INIT ERROR: ', err);
                localStorage.clear();
                location.href = `${Base_API.pathWeb}/n-health/mycard`
            }
        })
    }
    
    const authorizeChannel = (jwtData) => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            
            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
            
            if(!!signin_data_enc)
            {
                let signInData = DecryptedOBJ(signin_data_enc);

                let rawReq = {
                    "refEXP": signInData.refEXP,
                    "isType": signInData.isType,
                    "refAction": signInData.refAction,
                    "refType": signInData.refType,
                    "data":  {
                        "ref_display": lineProfile.display_name,
                        "ref_profile": lineProfile.picture_url,
                        "ref_user": lineProfile.user_id,
                        "ref_token": !!lineProfile.id_token ? lineProfile.id_token : "",
                        "ref_more1":"",
                        "ref_more2":"",
                        "ref_more3":"",
                        "ref_more4":"",
                        "ref_more5": ""
                    }
                }
                let reqData = {
                    "data": EncryptedOBJ(rawReq)
                }
                NhealthAction.AuthorizeChannel(reqData, headers)
                .then(res => {
                    console.log('res authorize channel: ', res)
                    if(res.IsSuccess)
                    {
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res))    
                        resolve(res);
                    }
                })
            }
        })
    }

    const getMemberInfoInit = () => {
        return new Promise(async resolve => {
            let memberInfo = !!localStorage.getItem('member_info') ? DecryptedOBJ(localStorage.getItem('member_info')) : null; 
            resolve(memberInfo);
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    // console.log('Get Member: ', res);
                    if(res.isSuccess === true)
                    {
                        resolve(res.member);
                    }else
                    {
                        if(res.errMessage === 'not found !.')
                        {
                            
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE);
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA);
                            location.reload();
                        }
                    }
                })
            }else
            {
               await useLineLogin(lineConfig.mycard)
            }
        })
    }

    const goToRegisCard = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
    }

    const getCardInit = (memberInfo) => {
        let cardId = memberInfo["cardid"];
        return new Promise(async resolve => {
            NhealthAction.GetCard(cardId)
            .then(async res => {
                if(res.isSuccess === true)
                {
                    let cardInfo = res.card;
                    cardInfo = {
                        ...cardInfo, 
                        cardNo: AddOn.cc_format(res.card.cardNo),
                        current_time_data: `ข้อมูล ณ ${moment().format('DD/MM/YYYY')} เวลา ${moment().format('HH:mm')}`,
                        point_expired: moment([new Date().getFullYear()]).endOf('year').format('DD/MM/YYYY')
                    }
                    setCardData(cardInfo);

                    await getCardDetailInit(res.card.tierLab);
                    resolve();
                }
                // console.log("Card Info: ", res.card);
            })
        })
    }

    const getCardDetailInit = async(tierLab) => {
        NhealthAction.GetInfoCardDetail(tierLab)
        .then(async res => {
            // console.log('Res Get Info Card Detail: ', res);
            if(res.isSuccess === true)
            {
                setCardDetail(res.info);
                return;
            }
        })
    }

    const handleLoader = (status) => {
        if(status === 'active')
        {
            setLoading(true);
        }else
        {
            setLoading(false);
        }
    }

    const handleOpenDetail = () => {
        setOpenDetail(true); 
        document.body.style.overflow = 'hidden'
    }

    const goToPointHistory = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/mycard/point-history`
    }

    const goToInviteFriends = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/mycard/invite-friends`
    }

    const goToMoreInfo = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/mycard/more-information`
    }

    const handleReloadPage = () => {
        window.location.reload();
    }

    const goToUpdateKYC = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/overview-1`;
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div 
                className="mycard-container"
            >
                {/* header text (name) */}
                <h1 className="header-text">
                    คุณ {cardData.cardFirstname} {cardData.cardLastname}
                </h1> 
                {/* card title */}
                <p className="card-title">
                    หมายเลขสมาชิก N Health : <span className="t-black">{cardData.cardNo}</span> 
                </p>
                {/* img (card) */}
                <div className="card-img-wrap">
                    <img 
                        src={cardData.cardImg_Lab} 
                        className="card-img"
                    />
                </div>
                {/* detail card */}
                <p 
                    className="detail-card"
                    onClick={handleOpenDetail}
                >
                    ดูรายละเอียดบัตร
                </p>
                {/* date detail */}
                <span 
                    className="date-detail"
                >
                    <img  
                        onClick={handleReloadPage} 
                        src={RefreshIcon}
                    />
                    {cardData.current_time_data}
                </span>
                {/* card information */}
                <div className="card-info">
                    <div className="badge-wrap">
                        <img src={cardData.tierLab === 0 ? cardData.cardIcon_Lab : SilverNhBadge_Inactive} />
                        <img src={cardData.tierLab === 1 ? cardData.cardIcon_Lab : GoldNhBadge_Inactive} />
                        <img src={cardData.tierLab === 2 ? cardData.cardIcon_Lab : PlatNhBadge_Inactive} />
                    </div> 
                    {/* my point wrap */}
                    <div className="mypoint-wrap">
                        {/* left */}
                        <div className="left">
                            <span className="mp-label">คะแนนของคุณ</span> 
                            <span className="mp t-black"><span className="mp-value">{Number(cardData.LabPoint).toLocaleString('th', {minimumFractionDigits: 0})}</span> คะแนน</span>
                        </div>
                        {/* right */}
                        <div className="right">
                            <button
                                onClick={goToPointHistory}
                            >
                                ดูประวัติคะแนน<img src={ArrowRight} />
                            </button>
                        </div>
                    </div>
                    {/* point remark */}
                    <div className="p-remark-wrap">
                        <p className="expiresIn">คะแนนจะหมดอายุภายใน {cardData.point_expired}</p>
                        <p className="p-remark"><span className="required-badge">*</span>เพียงใช้บริการ N Health เพื่อรับคะแนนสะสมอย่างน้อย 1 ครั้ง ก่อนวันที่คะแนนของคุณจะหมดอายุ</p>
                    </div>
                </div>
                {/* tab menu */}
                <div className="menu-wrap">
                    {/* item */}
                    <div 
                        className="item"
                        onClick={goToUpdateKYC}
                    >
                        <img src={UpdateKYC_ICON} /> 
                        <span>ข้อมูล KYC</span>
                    </div>
                    <div 
                        className="item"
                        onClick={goToMoreInfo}
                    >
                        <img src={CardMoreInfoIcon} /> 
                        <span>ข้อมูลเพิ่มเติม</span>
                    </div>
                    <div 
                        className="item"
                        onClick={goToInviteFriends}
                    >
                        <img src={InviteFriends} /> 
                        <span>เชิญเพื่อน</span>
                    </div>
                </div>
    
                <CardDetails openDetail={openDetail} setOpenDetail={setOpenDetail} cardData={cardData} cardDetail={cardDetail} />
                <Overlay openDetail={openDetail} setOpenDetail={setOpenDetail} />
            </div>
        )
    }
}

export default MyCard